
import { Component, Vue, Watch, Prop } from "vue-property-decorator"

@Component({
	components: {
	}
})
export default class Numeric extends Vue {
	@Prop({ default: null })
	public value?: string | number | null;

	@Prop({ type: Boolean, default: false })
	public readonly!: boolean;

	@Prop({ type: Number, default: 2 })
	public precision!: number;

	@Prop({ type: Number, default: null })
	public displayDecimals!: number | null;

	@Prop({ default: "" })
	public prepend!: string;

	@Prop({ default: null })
	public min?: number;

	@Prop({ default: null })
	public max?: number;

	@Prop({ default: false })
	public redIfInvalid!: boolean;

	@Prop({ default: false })
	public clearButton!: boolean

	@Prop({ default: null })
	public fixedWidth?: string | null

	@Prop({ default: 500 })
	public debounceTime!: number

	@Prop({ type: String, default: "" })
	public placeholder!: string

	public numberValue: number | null = null;

	private debounceInput: NodeJS.Timeout | null = null;

	private lastDebounceValue: number | null = null;
	private debounceValueToEmit: number | null = null;

	public mounted () {
		this.setValue(this.value)
	}

	get numberDisplayValue (): string {
		if (this.numberValue == null) {
			return ""
		}

		const numberString = this.numberValue.toString()
		if (this.displayDecimals) {
			const numberSplit = numberString.split(".")
			if (numberSplit.length < 2) {
				return numberString + ".00"
			}
			return numberSplit[0] + "." + numberSplit[1].padEnd(2, "0")
		}
		return numberString
	}

	get styleString () {
		return "width: " + this.fixedWidth + ";"
	}

	@Watch("value")
	onValueChanged (newValue: any) {
		if (newValue === this.numberValue) {
			return
		}
		if (newValue === "-" || newValue === "" || newValue === null || isNaN(parseFloat(newValue))) {
			this.setValue(newValue);
			(this.$refs.input as HTMLInputElement).value = ""
		} else {
			this.setValue(newValue)
		}
	}

	setValue (newValue: any) {
		if (newValue === "-" || newValue === "" || newValue === null || newValue === undefined) {
			this.$emit("input", null)
		}

		if (newValue) {
			if (typeof (newValue) !== "number") {
				newValue = parseFloat(newValue)
			}

			if (isNaN(newValue)) {
				newValue = this.numberValue
			} else {
				newValue = parseFloat(newValue.toFixed(this.precision))
			}
		}

		const oldValue = this.numberValue
		if (oldValue !== newValue) {
			newValue = newValue === "" ? null : newValue
			this.numberValue = newValue
			this.$emit("input", newValue)
		}
	}

	debounceValue (newValue: any, immediate = false) {
		// save resources by not setting the timeouts if nothing is listening
		if (!this.$listeners.debounce) {
			return
		}

		if (this.debounceInput) {
			clearTimeout(this.debounceInput)
			this.debounceInput = null
		}

		this.debounceValueToEmit = null

		if (!newValue) {
			this.debounceValueToEmit = null
		} else if (typeof (newValue) !== "number") {
			newValue = parseFloat(newValue)
			if (isNaN(newValue)) {
				this.debounceValueToEmit = null
			} else {
				this.debounceValueToEmit = newValue
			}
		}

		const oldValue = this.lastDebounceValue
		if (oldValue !== newValue) {
			if (immediate) {
				this.$emit("debounce", this.debounceValueToEmit)
				this.lastDebounceValue = newValue
			} else {
				this.debounceInput = setTimeout(async () => {
					this.$emit("debounce", this.debounceValueToEmit)
					this.lastDebounceValue = newValue
				}, this.debounceTime)
			}
		}
	}

	blurValue (newValue: number | string | null) {
		if (this.debounceInput) {
			this.debounceValue(newValue, true)
		}

		if (!newValue) {
			this.$emit("blur", null)
			return
		}

		if (typeof (newValue) !== "number") {
			newValue = parseFloat(newValue)
		}

		if (isNaN(newValue)) {
			newValue = null
		}

		this.$emit("blur", newValue)
	}

	clearValue () {
		this.setValue(null)
		this.debounceValue(null, true)
		this.blurValue(null)
	}
}
